import { SessionInterface } from "../../domain/interface/session_interface";
import { SessionRepository } from "../../domain/repository/session_repository";
import { SessionApiService } from "../data_source/session_api_service";


export class SessionRepositoryImpl implements SessionRepository {
    private sessionApiService: SessionApiService;

    constructor() {
        this.sessionApiService = new SessionApiService();
    }

    async getIncomingSession(skip: number, limit: number): Promise<{ sessions: SessionInterface[], fetchedAll: boolean }> {
        const response = await this.sessionApiService.getIncomingSession(skip, limit);

        if (response.status === 200) {
            const sessions: SessionInterface[] = [];
            for (const session of response.data.objects) {
                if (!session['_questionPoolId']) continue;
                sessions.push({
                    id: session['_id'],
                    title: session['title'],
                    vibesTheme: session['_questionPoolId']['title'],
                    meetingDuration: session['meetingDuration'],
                    start: new Date(Date.parse(session['startDate'])),
                    end: new Date(Date.parse(session['endDate'])),
                    visitAllowed: session['visitAllowed'],
                    formLink: session['formLink'] || undefined,
                });
            }
            return { sessions, fetchedAll: response.data.pages <= (skip / limit) + 1 };
        }
        throw new Error('Failed to fetch incoming sessions');
    }
}